import config from '@/config'
import { PAGE } from '@/constants/page.js'
import { v4 as uuidv4 } from 'uuid'
import Vue from 'vue'

export default {
  currentLang: function () {
    return Vue.i18n.locale()
  },
  getWholesaleStatus: function (state) {
    if (!state.pageProfile) return false
    try {
      // console.log(
      //   state.pageProfile.wholesale_status === true,
      //   state.wholesale,
      //   state.wholesale.length > 0,
      //   state.pageProfile.wholesale_status === true && state.wholesale && state.wholesale.length > 0
      // );
      return (
        state.pageProfile.wholesale_status === true &&
        state.wholesale &&
        state.wholesale.length > 0
      )
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
      return false
    }
  },
  getWholesale: function (state) {
    return state.wholesale
  },
  isEmptyCart: function (state) {
    return state.cart.length == 0
  },
  getCart: function (state, getters) {
    var resultCart = []
    var cart = state.cart.sort(function (a, b) {
      if (a > b) {
        return -1
      } else if (a < b) {
        return 1
      } else {
        return 0
      }
    })

    var total_quantity = 0
    try {
      if (cart && cart.length > 0)
        total_quantity = cart.reduce(
          (prev, curr) => prev + parseInt(curr.quantity),
          0
        )
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    }
    resultCart = cart.map(function (product) {
      var p = product
      var bundleproduct_quantity = 0
      var bundleproduct = cart.filter((c) => {
        return c.id == p.id
      })
      try {
        p.addon_json = JSON.parse(p.addon_json)
      } catch (error) {
        p.addon_json = p.addon_json || {}
      }

      bundleproduct.forEach((b) => {
        bundleproduct_quantity += b.quantity
      })

      let prodprice_total = 0
      let bundle = null
      if (
        state.pageProfile.wholesale_status &&
        state.wholesale &&
        state.wholesale.length > 0
      ) {
        p.bundle = product.quantity

        let wholesale = state.wholesale.find(function (bundle) {
          return (
            bundle.maxquantity >= total_quantity &&
            total_quantity >= bundle.minquantity
          )
        })
        if (wholesale) {
          try {
            prodprice_total = parseFloat(wholesale.price)
          } catch (error) {
            // eslint-disable-next-line
            console.error(error)
          }
          p.bundleprice = prodprice_total * product.quantity
          return p
        }
      } else {
        if (product.productbundle && !state.pageProfile.wholesale_status) {
          product.productbundle.filter((b) => {
            if (
              b.maxquantity >= bundleproduct_quantity &&
              bundleproduct_quantity >= b.minquantity
            ) {
              bundle = b
            }
          })
        }
      }

      if (bundle) {
        prodprice_total = parseFloat(bundle.price)
        p.bundleprice = prodprice_total * product.quantity
        return p
      }
      if (product.price != product.discountprice) {
        p.bundleprice = parseFloat(product.discountprice) * product.quantity
        return p
      }
      p.bundleprice = parseFloat(product.price) * product.quantity
      return p
    })

    resultCart = resultCart.map((el) => {
      let vat_val = 0
      try {
        vat_val = getters.getPageProfile.vat
      } catch (error) {
        //
      }
      if (el.vat_types == 'include') {
        let price_before_vat = (el.bundleprice * 100) / (100 + vat_val)
        price_before_vat = Math.round(price_before_vat * 100) / 100
        el.priceBeforeVat = price_before_vat
      } else if (el.vat_types == 'exclude') {
        el.priceBeforeVat = el.bundleprice
      } else {
        el.priceBeforeVat = el.bundleprice
      }
      el.vat = Math.abs(el.bundleprice - el.priceBeforeVat)

      let additional_price = 0
      if (
        getters.getPageProfile &&
        getters.getPageProfile.type == 'reka' &&
        el.addon_json &&
        el.addon_json.embroideredNameList &&
        el.addon_json.embroideredNameList.length > 0
      ) {
        //
        let embroideredNameList = el.addon_json.embroideredNameList.filter(
          (el) => {
            return el || el != ''
          }
        )
        if (embroideredNameList.length > 0)
          additional_price = embroideredNameList.length * 100
      }

      el.additional_price = additional_price
      el.rand_id = uuidv4()
      return el
    })

    return resultCart
  },
  totalVat(state, getters) {
    let total = 0
    try {
      total = getters.getCart.reduce((prev, curr) => {
        let vat = getters.getPageProfile.vat || 0
        if (curr.vat_types == 'include' || curr.vat_types == 'exclude') {
          prev =
            prev + Math.round(((curr.priceBeforeVat * vat) / 100) * 100) / 100
        } else {
          //
        }
        return prev
      }, 0)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
    // console.log(total);
    return total
  },
  totalBeforeVat(state, getters) {
    let total = 0
    try {
      total = getters.getCart.reduce((prev, curr) => {
        prev += curr.priceBeforeVat
        return prev
      }, 0)
    } catch (error) {
      //
    }
    total = Math.round(total * 100) / 100
    return total
  },
  getPageProfile: function (state) {
    var profile = { ...state.pageProfile }
    if (!profile || !profile.pageid) return false
    profile.type = 'default'
    if (profile && profile.ispremium == true) {
      if (state.bearhouse.includes(profile.pageid)) {
        profile.type = 'bearhouse'
      } else if (state.khaiwhan.includes(profile.pageid)) {
        profile.type = 'khaiwhan'
      } else if (state.ros.includes(profile.pageid)) {
        profile.type = 'ros'
      } else if (
        [
          '103045347810541',
          '2154616301525189',
          '356805901794673',
          '1924579627803469',
          '104679561577508',
          '493004761144617',
          '934400496731284',
          '330946854291292',
          '301557697175910',
          // "109008520721534",
          '100160834719075'
        ].includes(profile.pageid)
      ) {
        profile.type = 'gaigao'
      } else if (['114660513608160'].includes(profile.pageid)) {
        profile.type = 'forex'
      } else if (
        ['105256301109350', '100750874824298'].includes(profile.pageid)
      ) {
        profile.type = 'purelife'
      } else if (
        [
          '148831989096546',
          '1229692217050821',
          '135565533158593',
          '488563718210335',
          '799590883441878'
        ].includes(profile.pageid)
      ) {
        profile.type = 'monobo'
      } else if (['113937150302402'].includes(profile.pageid)) {
        profile.type = 'ros'
      } else if (
        [
          '155062857877705',
          '107057644128258',
          '119155854798330',
          '104193847860106',
          '544685655592193'
        ].includes(profile.pageid)
      ) {
        profile.type = 'smoothe'
      } else if (
        ['104974550989962', '100855974907941'].includes(profile.pageid)
      ) {
        profile.type = 'gaigacha'
      } else if (['1775425925847885'].includes(profile.pageid)) {
        profile.type = 'kanom'
      } else if (['104944601303072'].includes(profile.pageid)) {
        profile.type = 'waratapob'
      } else if (
        ['bec'].includes(profile.theme) ||
        ['505923009941524', '456187931239759'].includes(profile.pageid)
      ) {
        profile.type = 'bec'
      } else if (
        ['108973710878860', '326180737483767'].includes(profile.pageid)
      ) {
        profile.type = 'rabbit'
      } else if (
        ['102459484852582', '102438735480946'].includes(profile.pageid)
      ) {
        profile.type = 'nvbb'
      } else if (['102434044554028'].includes(profile.pageid)) {
        profile.type = 'fastdeli'
      } else if (
        ['111149990806742', '217986362107539'].includes(profile.pageid)
      ) {
        //, "107410831174668"
        profile.type = 'constructpage'
      } else if (
        ['176922345693076', '809510349133469', '103876431747147'].includes(
          profile.pageid
        )
      ) {
        profile.type = 'chillpainai'
      } else if (['runkan'].includes(profile.theme)) {
        profile.type = 'runkan'
      } else if (['104716585038207', '362065616073'].includes(profile.pageid)) {
        profile.type = 'cutepress'
      } else if (
        ['145969602635827', '100164365566364'].includes(profile.pageid)
      ) {
        profile.type = 'alice'
      } else if (['1954711867904582'].includes(profile.pageid)) {
        profile.type = 'mookata'
      } else if (
        ['330339053719456', '105314948276699'].includes(profile.pageid)
      ) {
        profile.type = 'tero'
      } else if (
        ['102033922225647', '101608865174945'].includes(profile.pageid)
      ) {
        profile.type = 'reka'
      } else if (
        ['105077088474056', '1192315994209757'].includes(profile.pageid)
      ) {
        profile.type = 'foodguru'
      } else if (['103615798930866'].includes(profile.pageid)) {
        profile.type = 'thaiairways'
      } else if (
        ['134182372147489', '623635804423191'].includes(profile.pageid)
      ) {
        profile.type = 'lukkaithong'
      } else if (['105432182130709'].includes(profile.pageid)) {
        profile.type = 'cityfresh'
      } else if (
        [
          '108234815144840',
          '1037700739663223',
          '110981841237323',
          '101542172593323'
        ].includes(profile.pageid)
      ) {
        profile.type = 'nestle'
      } else if ([...PAGE.POWERBUY_SHOP_SERVICES].includes(profile.pageid)) {
        profile.type = 'powerbuy'
        profile.mainPage = PAGE.POWERBUY_MAIN_PAGE
      } else if ([...PAGE.TREMENDOUS].includes(profile.pageid)) {
        profile.type = 'tremendous'
      } else if ([...PAGE.SEAGULL].includes(profile.pageid)) {
        profile.type = 'seagull'
      } else if ([...PAGE.YASALE].includes(profile.pageid)) {
        profile.type = 'yasale'
      }
    }

    if (['396306053873110', '115414076948160'].includes(profile.pageid)) {
      profile.type = 'bec'
    }

    profile.allowtransfer =
      profile.allowtransfer == true || profile.allowtransfer == 'true'

    profile.vat =
      ['998122266996445'].includes(profile.pageid) ||
      profile.type == 'lukkaithong'
        ? 7
        : 0

    return profile
  },
  getLoadingPageProfile: function (state) {
    return state.loadingPageProfile
  },
  getTheme: function (state) {
    return state.theme
  },
  getIosPadding() {
    var isPadding = false
    if (
      navigator.userAgent.indexOf('FB') != -1 ||
      (navigator.userAgent.indexOf('Line') != -1 &&
        navigator.userAgent.indexOf('iphone') != -1)
    ) {
      isPadding = true
    }
    return isPadding
  },
  getSalePage: function (state) {
    return state.salePage
  },
  currencySign(state, getters) {
    if (getters.getPageProfile) {
      if (state.usdCurrency.includes(getters.getPageProfile.pageid)) {
        return '$'
      } else if (
        state.myanmarCurrency.includes(getters.getPageProfile.pageid)
      ) {
        return 'K'
      } else if (state.wonCurrency.includes(getters.getPageProfile.pageid)) {
        return '₩'
      } else if (state.kipCurrency.includes(getters.getPageProfile.pageid)) {
        return '₭'
      } else if (state.poundCurrency.includes(getters.getPageProfile.pageid)) {
        return '£'
      } else if (
        state.tkBangladeshCurrency.includes(getters.getPageProfile.pageid)
      ) {
        return '৳'
      }
    }
    return '฿'
  },
  isPowerBuyPage(state) {
    return state.shop_main_pageid && config.env == 'shopcommu'
  },
  isThailandPostMart(state, getters) {
    return getters.getPageProfile.type === 'bec'
  }
}
